import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';  
import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../smr-tap-retry/smr-tap-retry.module';
import { ClientInfoComponent } from './client-info.component';
import { ClientFormPageComponentModule } from '../client-form-page/client-form-page.module';
import { CardOnFileComponentModule } from '../card-on-file/card-on-file.module';
@NgModule({
    declarations: [
        ClientInfoComponent
    ],
    imports: [
        IonicModule,
        SalonMonsterLoadMaskModule,
        SalonMonsterTapRetryModule,
        CommonModule,
        ClientFormPageComponentModule,
        CardOnFileComponentModule
    ],
    exports: [
        ClientInfoComponent
    ],
    providers: []
})
export class ClientInfoModule {}
